function c24LoginBannerTrigger() {
    var C24App = window.C24App;
    if (!C24App) {
        return;
    }

    function isiOSBridgeAvailable() {
        return (
            window.webkit !== undefined
            && window.webkit.messageHandlers !== undefined
            && window.webkit.messageHandlers.aiBotBridge !== undefined
        );
    }
    function isAndroidBridgeAvailable() {
        return window.aiBotBridge !== undefined;
    }

    var isBridgeAvailable = (
        (isiOSBridgeAvailable() || isAndroidBridgeAvailable())
    );
    if (!isBridgeAvailable) {
        return;
    }
    C24App.setProduct({productSSO: 'hkv', showSearchItem: false});
    C24App.triggerUnifiedLogin('hkv_unified_login');
}

window.c24LoginBannerTrigger = c24LoginBannerTrigger;

window.addEventListener('unified-login', function () {
    window.location.reload();
});
